import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcLocation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.5A6.5 6.5 0 0 0 5.5 10c0 2.018.9 4.123 2.113 6.026 1.205 1.891 2.668 3.506 3.682 4.526a.98.98 0 0 0 1.416.003c1.015-1.013 2.476-2.618 3.679-4.506C17.6 14.15 18.5 12.04 18.5 10A6.5 6.5 0 0 0 12 3.5M4 10a8 8 0 1 1 16 0c0 2.453-1.069 4.852-2.345 6.855-1.284 2.015-2.827 3.706-3.884 4.761a2.48 2.48 0 0 1-3.54-.006c-1.055-1.061-2.599-2.762-3.883-4.778C5.07 14.828 4 12.433 4 10",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.055 8.309a2.67 2.67 0 0 1 1.943-.809c.75 0 1.412.275 1.943.805a2.67 2.67 0 0 1 .809 1.943 2.68 2.68 0 0 1-.805 1.943 2.67 2.67 0 0 1-1.943.809 2.68 2.68 0 0 1-1.943-.805 2.67 2.67 0 0 1-.809-1.943c0-.75.275-1.412.805-1.943M11.998 9c-.35 0-.63.116-.88.368a1.18 1.18 0 0 0-.368.884c0 .35.116.63.367.88.253.252.534.368.885.368.35 0 .63-.116.88-.367.252-.253.368-.534.368-.885 0-.35-.116-.63-.367-.88A1.18 1.18 0 0 0 11.998 9",
    clipRule: "evenodd"
  }));
}
var IcLocation = createNolIcon(/*#__PURE__*/forwardRef(SvgIcLocation));

export { IcLocation as I };
